import { Percent, Store, ArrowUpRight } from "lucide-react";

/** Encart discret et permanent affiché sur TOUTES les pages événements :
 *  un petit mot + lien vers Débouche Discount 28 et vers PROXIreduc-28. */
export default function EventBrandMentions({ testId = "event-brand-mentions" }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid={testId}>
      <a href="https://debouche-discount-28.com" target="_blank" rel="noopener noreferrer"
         data-testid="event-brand-debouche"
         className="group flex items-start gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 hover:border-[#E05638] transition-colors">
        <span className="shrink-0 grid place-items-center w-9 h-9 rounded-lg bg-orange-50 text-[#E05638]">
          <Percent size={18} />
        </span>
        <span className="min-w-0">
          <span className="font-semibold text-slate-900 text-sm inline-flex items-center gap-1">
            Débouche Discount 28 <ArrowUpRight size={13} className="opacity-50 group-hover:opacity-100 transition-opacity" />
          </span>
          <span className="block text-xs text-slate-500 leading-snug">
            Débouchage de canalisations à Chartres et en Eure-et-Loir.
          </span>
        </span>
      </a>

      <a href="https://proxireduc-28.com" target="_blank" rel="noopener noreferrer"
         data-testid="event-brand-proxireduc"
         className="group flex items-start gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 hover:border-[#E05638] transition-colors">
        <span className="shrink-0 grid place-items-center w-9 h-9 rounded-lg bg-rose-50 text-[#E05638]">
          <Store size={18} />
        </span>
        <span className="min-w-0">
          <span className="font-semibold text-slate-900 text-sm inline-flex items-center gap-1">
            PROXIreduc-28 <ArrowUpRight size={13} className="opacity-50 group-hover:opacity-100 transition-opacity" />
          </span>
          <span className="block text-xs text-slate-500 leading-snug">
            Retrouvez tous nos commerçants et bons plans locaux.
          </span>
        </span>
      </a>
    </div>
  );
}
